import { request } from '@/shared/api/request'

export const save = (payload) => {
	return request({ url: 'colcontract/industryAgreement/save', method: 'POST', data: payload })
}
